import React, { useEffect, useRef, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Teaxtarea from "../../../components/elements/form/textarea";
import Button from "../../../components/elements/button";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import toast from "react-hot-toast";
import FileUpload from "../../../components/elements/form/fileUplaod";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import Signaturepad from "../../../components/signaturepad";
import Loader from "../../../components/loader";

interface AssetsFormProps {
  _ref?: any;
  editData?: any;
  currentStatus?:any;
  onCreate?: () => void;
  onCancel?: () => void;
}

type CreateWorkOrderFormValueType = {
  workOrderID: any;
  CompletionNote :any;
  rootCause:any;
  Files:any;
  assetImage: any;
};

const CancelModalWorkOrder: React.FC<AssetsFormProps> = ({ _ref, editData, currentStatus, onCreate = () => {}, onCancel = () => {} }) => {
  const { control, handleSubmit, setValue, reset, formState: { errors }, watch, getValues } = useForm<CreateWorkOrderFormValueType>({
    defaultValues: {    
    }
  });
  const { showLoader, hideLoader } = useAppLoader();    
  
  const [ woloader, setWoloader ] = useState<boolean>(false);
  const [Files, setFiles] = React.useState<any>(null);
  const [partsAttachment, setPartsAttachment] = useState<any>(null);

  const workOrderAPI: any = useWorkOrderApi();
  
  const hasEditRun = useRef(false);


  const formReset = async () => {
    setValue("CompletionNote", null);
    setValue("rootCause", null);
    setValue("assetImage", null);    
    setFiles(null);  
  };

  const onSubmit: SubmitHandler<CreateWorkOrderFormValueType> = (data: any) => {
    if (Files) {
      const payloadData = new FormData();
      payloadData.append("workOrderID", editData?.workOrderID);
      payloadData.append("CompletionNote", data?.CompletionNote);
      payloadData.append("workOrderStatusID", currentStatus)
      payloadData.append('SignatureFiles', Files)

      console.log("data is -> ", data);
      console.log("payload is-> ", payloadData);
      setWoloader(true);
      workOrderAPI.SaveWorkOrderCompletion(payloadData, async (resp: any) => {      
        if (partsAttachment) {
          const formData = new FormData();
          var i = 0;
          for (const item of partsAttachment) {
            formData.append("InputFile" + i, item);
            i++;
          }
        
          console.log("partsAttachment", partsAttachment);
          /*
          for (let i = 0; i < partsAttachment.length; i++) {
            formData.append("InputFile" + i, partsAttachment[i]);
          }
          */
          formData.append("WorkOrderstatus", "Cancelled");
          formData.append("workOrderID", resp?.returnID);        
          const uploadResp = await new Promise((resolve, reject) => {
            workOrderAPI.UploadWorkOrderCompletionAttachment(formData, (resp: any) => {
              toast.success(resp?.message);            
              resolve(resp);
            }, (error: any) => {
                toast.error(error);
                reject(error);
            });
          }).catch((error: any) => {return null})
        }      
        toast.success(resp?.message);
        hasEditRun.current = false;
        setWoloader(false);
        formReset();        
        onCreate();        
        
      }, (error: any) => {
        toast.error(error);
        setWoloader(false);
      });
    } else {
      toast.error("Please add signature in order to proceed the WO!");
      return false;
    }
   // console.log("Submit payload", payload);
  };

  const changeAttachmentHandler = (e: any) => {
    setPartsAttachment(e.target.files);
  };

  const init_page_date =  async() => {   
  }

  useEffect(() => {
    init_page_date();    
  }, []);  

  useEffect(() => {
    if (editData) {
      if (!hasEditRun.current){
        console.log("editData", editData);      
        hasEditRun.current = true;
      }
    } else {
      formReset();
    }
  }, [ editData ]);

  useEffect(() => {
    if (_ref?.current) {
      _ref.current.reset = formReset;
    }
  }, [_ref]);

  return (
    <div>
      {woloader && (
        <div className={ `absolute p-8` } style={{ height: "100%", width: "100%", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.5)" }}>
          <Loader />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className={ `${woloader? `hidden`: `flex`} flex-col` }>
        <div className="flex-1 overflow-auto" style={{ minHeight: `calc(100vh - 152px)` }}>
            <Controller
              name="CompletionNote"
              rules={{ required: "Cancellation Note is required" }}
              control={control}
              render={({ field: { value, onChange } }) => (
                <Teaxtarea
                  label="Cancellation Note"
                  value={value}
                  onChange={onChange}
                  required
                  placeholder="Cancellation Note"
                  error={errors.CompletionNote?.message as any}
                />
              )}
            />
            <Controller
              name="Files"   
              control={control} 
              render={({ field: { value, onChange } }) => (
                <Signaturepad
                  onComplete={(data, file) => {
                    console.log("Signature completed", data);
                    console.log("Signature File -> ", file);
                    setFiles(file);
                  }}     
                />
              )}
            />
            <Controller
              name="assetImage"
              control={control}
              render={({ field: { value, onChange } }) => (
                <FileUpload
                  label="File name"
                  value={value}
                  isMulti={true}
                  accept=".jpg, .jpeg, .png"
                  isFigmaType={true}
                  allowedExt={[`png`, `jpg`, `jpeg`, `gif`]}
                  retainFiles={true}
                  onChange={(e: any, files:any) => {
                    changeAttachmentHandler(e);
                    onChange(e.target.files[0]);
                  }}
                  placeholder="Choose Files"
                />
              )}
            />

        </div>

        <div className="flex justify-end gap-2 flex-shrink-0 pt-5 pb-1 border-t" style={{ borderTopColor: `#50575B` }}>
          <Button type="submit" customstyle={{ background: `#2D6A32`, width: 142, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}>Save</Button>
          <Button type="button" theme="secondary" onClick={() => {
              hasEditRun.current = false;
              formReset();
              onCancel();
            }}
            customstyle={{ width: 97, height: 40 }} childstyle={{ justifyContent: `center`, fontSize: 15 }}
          >
            Cancel
          </Button>        
        </div>
      </form>
    </div>
  );
};

export default CancelModalWorkOrder;
